import { defaultApi } from '@/api';

export interface BudgetRoadmapVisible {
  id: number;
  title: string;
  type: 'big' | 'small';
  roadmap_id: number;
  created_at: string;
  updated_at: string;
}

export async function getBudgetRoadmapVisible({ roadmapId }: { roadmapId: number }) {
  const { data } = await defaultApi.get<{
    success: boolean;
    data: BudgetRoadmapVisible[];
  }>(`/budget-roadmap-visible/roadmap/${roadmapId}`);
  return data.data;
}

export async function createBudgetRoadmapVisible({
  roadmapId,
  newRoadmapVisible,
}: {
  roadmapId: number;
  newRoadmapVisible: { title: string; type: 'big' | 'small' };
}) {
  const { data } = await defaultApi.post<{
    success: boolean;
    data: BudgetRoadmapVisible;
  }>(`/budget-roadmap-visible/${roadmapId}`, newRoadmapVisible);
  return data.data;
}

export async function deleteBudgetRoadmapVisible({ fieldId }: { fieldId: number }) {
  const { data } = await defaultApi.delete<{
    success: boolean;
    message: string;
  }>(`/budget-roadmap-visible/${fieldId}`);
  return data;
}